var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
        home: true,
        'is-from-crm-family': _vm.isFromCrmFamily(),
    }},[_c('nav-page'),_c('router-view'),_c('nav-footer'),_c('side-nav')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }